import React from 'react';

const RELEASES_URL = 'https://github.com/klaudia1209teleworker/teleworker/releases';

const PageFooter: React.FC = () => {
  return (
    <footer className="mt-8 pt-4 border-t border-gray-200 text-center">
      <a
        href={RELEASES_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-primary hover:text-primary-dark"
      >
        Release Notes
      </a>
    </footer>
  );
};

export default PageFooter;
